import {
	GeneralDocument,
	generalDocumentQuery,
	type ResolvedDoc,
} from '#app/components/general-document.tsx'
import { safeFetch } from '#app/utils/sanity.server.ts'
import { type Route } from './+types/mission.ts'

export async function loader() {
	const doc = await safeFetch<ResolvedDoc | null>(
		`*[_type == "generalDocument" && name == "mission"][0]${generalDocumentQuery}`,
	)
	return { doc }
}

export default function MissionTab({ loaderData }: Route.ComponentProps) {
	return <GeneralDocument doc={loaderData.doc} />
}
